/* eslint-disable arrow-body-style */
import React, { Component } from "react";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import { connect } from "react-redux";
import { fatcaCrsAction } from "shared/store/actions";
import selectors from "shared/store/selectors";
import {
  PaddedContainer,
  Label,
  Heading,
  ButtonPlus,
  Options,
  SelectBox,
  FormElementContainer,
  Input,
  SimpleSelectBox,
  Textarea,
  Notes,
} from "components";
import { FORM_KEYS } from "shared/constant";
import arrOptions from "shared/constant/arrOptions";
import { isEmpty } from "lodash";
import validation from "shared/validations";
import utils from "shared/helpers/utils";

class Crs extends Component {
  onElementChange = ({ target: { name, value } }) => {
    this.props.onUpdateCrs(name, value);
  };

  onBoolChange = ({ target: { name, id } }) => {
    const { getStringAfterSpecialChar } = utils;
    const selected = getStringAfterSpecialChar(id, "_");
    this.props.onUpdateCrs(name, selected);
  };

  onHandleSelect = (index, name, value) => {
    const { COUNTRY_TAX } = FORM_KEYS;
    const { onUpdateCountryTax, civilId } = this.props;
    onUpdateCountryTax(index, name, value);

    // console.log('update tin ', value, value === 'Kuwait');
    if (value === "Kuwait") {
      onUpdateCountryTax(index, COUNTRY_TAX.TIN, civilId);
    } else {
      onUpdateCountryTax(index, COUNTRY_TAX.TIN, "");
    }
  };

  onCountryTaxChange = (index, { target: { name, value } }) => {
    this.props.onUpdateCountryTax(index, name, value);
  };

  onUpdateIsTin = (index, name, e) => {
    const { getStringAfterSpecialChar } = utils;
    const selected = getStringAfterSpecialChar(e.target.id, "_");
    // console.log('ISTIN', name, e.target.id, e.target.value, selected.slice(0, selected.length - 1));
    this.props.onUpdateCountryTax(
      index,
      name,
      selected.slice(0, selected.length - 1),
    );
  };

  handleRemoveCountryTax = (id) => {
    this.props.onRemoveCountryTax(id);
  };

  getJurisdictions = (excludingKuwait) => {
    const { jurisdictions } = arrOptions;
    if (excludingKuwait) {
      return jurisdictions.filter((p) => p !== "Kuwait").sort();
    }
    return jurisdictions.sort();
  };

  render() {
    const {
      intl,
      question1,
      question2,
      question3,
      question4,
      question5,
      question6,
      residentJurisdiction,
      residenceAddress,
      telephone,
      standingInstruction,
      holdMail,
      effectivePoa,
      taxList,
      onAddMoreCountryTax,
      isSubmitClicked,
      clientDetails,
      civilId,
    } = this.props;
    const { CRS, COUNTRY_TAX } = FORM_KEYS;
    const { fatcaCrsOptions, taxReasonOptions } = arrOptions;
    const {
      crsSchema: {
        crsQ1Schema,
        crsQ2Schema,
        crsQ3Schema,
        crsQ4Schema,
        crsQ5Schema,
        crsQ6Schema,
      },
      // countryTaxSchema: { countryTaxFieldsSchema },
      getErrorMessages,
    } = validation;

    const elementValidation = {
      [CRS.CRS_Q1]: {
        isValid: crsQ1Schema(intl, CRS.CRS_Q1, question1).isValidSync({
          crsQ1: question1,
        }),
        errorMessage: getErrorMessages(
          { crsQ1: question1 },
          crsQ1Schema(intl, CRS.CRS_Q1, question1),
        ),
      },
      [CRS.RESIDENT_REPORTABLE_JURISDICTION]: {
        isValid: crsQ1Schema(
          intl,
          CRS.RESIDENT_REPORTABLE_JURISDICTION,
          question1,
        ).isValidSync({
          residentOfReportableJurisdiction: residentJurisdiction,
        }),
        errorMessage: getErrorMessages(
          { residentOfReportableJurisdiction: residentJurisdiction },
          crsQ1Schema(intl, CRS.RESIDENT_REPORTABLE_JURISDICTION, question1),
        ),
      },

      [CRS.CRS_Q2]: {
        isValid: crsQ2Schema(intl, CRS.CRS_Q2, question2).isValidSync({
          crsQ2: question2,
        }),
        errorMessage: getErrorMessages(
          { crsQ2: question2 },
          crsQ2Schema(intl, CRS.CRS_Q2, question2),
        ),
      },
      [CRS.RESIDENCE_ADDRESS]: {
        isValid: crsQ2Schema(
          intl,
          CRS.RESIDENCE_ADDRESS,
          question1,
        ).isValidSync({ residenceAddress }),
        errorMessage: getErrorMessages(
          { residenceAddress },
          crsQ2Schema(intl, CRS.RESIDENCE_ADDRESS, question2),
        ),
      },

      [CRS.CRS_Q3]: {
        isValid: crsQ3Schema(intl, CRS.CRS_Q3, question3).isValidSync({
          crsQ3: question3,
        }),
        errorMessage: getErrorMessages(
          { crsQ3: question3 },
          crsQ3Schema(intl, CRS.CRS_Q3, question3),
        ),
      },
      [CRS.TELEPHONE_NUMBER]: {
        isValid: crsQ3Schema(intl, CRS.TELEPHONE_NUMBER, question3).isValidSync(
          { telephoneNumber: telephone },
        ),
        errorMessage: getErrorMessages(
          { telephoneNumber: telephone },
          crsQ3Schema(intl, CRS.TELEPHONE_NUMBER, question3),
        ),
      },

      [CRS.CRS_Q3]: {
        isValid: crsQ3Schema(intl, CRS.CRS_Q3, question3).isValidSync({
          crsQ3: question3,
        }),
        errorMessage: getErrorMessages(
          { crsQ3: question3 },
          crsQ3Schema(intl, CRS.CRS_Q3, question3),
        ),
      },
      [CRS.TELEPHONE_NUMBER]: {
        isValid: crsQ3Schema(intl, CRS.TELEPHONE_NUMBER, question3).isValidSync(
          { telephoneNumber: telephone },
        ),
        errorMessage: getErrorMessages(
          { telephoneNumber: telephone },
          crsQ3Schema(intl, CRS.TELEPHONE_NUMBER, question3),
        ),
      },

      [CRS.CRS_Q4]: {
        isValid: crsQ4Schema(intl, CRS.CRS_Q4, question4).isValidSync({
          crsQ4: question4,
        }),
        errorMessage: getErrorMessages(
          { crsQ4: question4 },
          crsQ4Schema(intl, CRS.CRS_Q4, question4),
        ),
      },
      [CRS.HOLD_MAIL]: {
        isValid: crsQ4Schema(intl, CRS.HOLD_MAIL, question4).isValidSync({
          holdMail,
        }),
        errorMessage: getErrorMessages(
          { holdMail },
          crsQ4Schema(intl, CRS.HOLD_MAIL, question4),
        ),
      },

      [CRS.CRS_Q5]: {
        isValid: crsQ5Schema(intl, CRS.CRS_Q5, question5).isValidSync({
          crsQ5: question5,
        }),
        errorMessage: getErrorMessages(
          { crsQ5: question5 },
          crsQ5Schema(intl, CRS.CRS_Q5, question5),
        ),
      },
      [CRS.STANDING_INSTRUCTION]: {
        isValid: crsQ5Schema(
          intl,
          CRS.STANDING_INSTRUCTION,
          question5,
        ).isValidSync({ standingInstruction }),
        errorMessage: getErrorMessages(
          { standingInstruction },
          crsQ5Schema(intl, CRS.STANDING_INSTRUCTION, question5),
        ),
      },

      [CRS.CRS_Q6]: {
        isValid: crsQ6Schema(intl, CRS.CRS_Q6, question6).isValidSync({
          crsQ6: question6,
        }),
        errorMessage: getErrorMessages(
          { crsQ6: question6 },
          crsQ6Schema(intl, CRS.CRS_Q6, question6),
        ),
      },
      [CRS.EFFECTIVE_POA]: {
        isValid: crsQ6Schema(intl, CRS.EFFECTIVE_POA, question6).isValidSync({
          effectivePoa,
        }),
        errorMessage: getErrorMessages(
          { effectivePoa },
          crsQ6Schema(intl, CRS.EFFECTIVE_POA, question6),
        ),
      },

      // [COUNTRY_TAX.COUNTRY_JURISDICTION]: {
      //   isValid: countryTaxFieldsSchema(intl, COUNTRY_TAX.COUNTRY_JURISDICTION).isValidSync({ countryJurisdiction }),
      // },
    };

    const countryTax = taxList;
    const isCountryTaxValid = validation.countryTaxSchema
      .countryTaxListSchema(intl, countryTax)
      .isValidSync({ countryTax });

    const modifyOptions = (name) => {
      if (!Array.isArray(fatcaCrsOptions)) return null;
      const newArr = [];

      fatcaCrsOptions.forEach((item) => {
        newArr.push({
          id: `${name}_${item.id}`,
          label: item.label,
        });
      });

      return newArr;
    };

    const isKuwaiti = clientDetails.nationality === "Kuwaiti";
    const translateAnswer = (str) => {
      return str ? intl.formatMessage({ id: str.toLowerCase() }) : str;
    };

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === "AR"}>
        <Heading title={intl.formatMessage({ id: "crs.indicia" })} />

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q1" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q1}
            optionList={modifyOptions(CRS.CRS_Q1)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question1)}
            isValid={elementValidation[CRS.CRS_Q1].isValid}
            errorMessage={elementValidation[CRS.CRS_Q1].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question1) === intl.formatMessage({ id: "yes" }) ||
          question1 === `${CRS.CRS_Q1}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Input
              label={intl.formatMessage({ id: "crs.q1.ifYes" })}
              placeholder={intl.formatMessage({
                id: "crs.q1.ifYes.placeholder",
              })}
              name={CRS.RESIDENT_REPORTABLE_JURISDICTION}
              onInputChange={this.onElementChange}
              value={residentJurisdiction}
              isValid={
                elementValidation[CRS.RESIDENT_REPORTABLE_JURISDICTION].isValid
              }
              errorMessage={
                elementValidation[CRS.RESIDENT_REPORTABLE_JURISDICTION]
                  .errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q2" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q2}
            optionList={modifyOptions(CRS.CRS_Q2)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question2)}
            isValid={elementValidation[CRS.CRS_Q2].isValid}
            errorMessage={elementValidation[CRS.CRS_Q2].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question2) === intl.formatMessage({ id: "yes" }) ||
          question2 === `${CRS.CRS_Q2}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Textarea
              label={intl.formatMessage({ id: "crs.q2.ifYes" })}
              name={CRS.RESIDENCE_ADDRESS}
              onInputChange={this.onElementChange}
              value={residenceAddress}
              isValid={elementValidation[CRS.RESIDENCE_ADDRESS].isValid}
              errorMessage={
                elementValidation[CRS.RESIDENCE_ADDRESS].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q3" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q3}
            optionList={modifyOptions(CRS.CRS_Q3)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question3)}
            isValid={elementValidation[CRS.CRS_Q3].isValid}
            errorMessage={elementValidation[CRS.CRS_Q3].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question3) === intl.formatMessage({ id: "yes" }) ||
          question3 === `${CRS.CRS_Q3}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Input
              label={intl.formatMessage({ id: "crs.q3.ifYes" })}
              name={CRS.TELEPHONE_NUMBER}
              onInputChange={this.onElementChange}
              value={telephone}
              isValid={elementValidation[CRS.TELEPHONE_NUMBER].isValid}
              errorMessage={
                elementValidation[CRS.TELEPHONE_NUMBER].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q4" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q4}
            optionList={modifyOptions(CRS.CRS_Q4)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question4)}
            isValid={elementValidation[CRS.CRS_Q4].isValid}
            errorMessage={elementValidation[CRS.CRS_Q4].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question4) === intl.formatMessage({ id: "yes" }) ||
          question4 === `${CRS.CRS_Q4}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Textarea
              label={intl.formatMessage({ id: "crs.q4.ifYes" })}
              name={CRS.HOLD_MAIL}
              onInputChange={this.onElementChange}
              value={holdMail}
              isValid={elementValidation[CRS.HOLD_MAIL].isValid}
              errorMessage={elementValidation[CRS.HOLD_MAIL].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q5" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q5}
            optionList={modifyOptions(CRS.CRS_Q5)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question5)}
            isValid={elementValidation[CRS.CRS_Q5].isValid}
            errorMessage={elementValidation[CRS.CRS_Q5].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question5) === intl.formatMessage({ id: "yes" }) ||
          question5 === `${CRS.CRS_Q5}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Input
              label={intl.formatMessage({ id: "crs.q5.ifYes" })}
              name={CRS.STANDING_INSTRUCTION}
              onInputChange={this.onElementChange}
              value={standingInstruction}
              isValid={elementValidation[CRS.STANDING_INSTRUCTION].isValid}
              errorMessage={
                elementValidation[CRS.STANDING_INSTRUCTION].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <FormElementContainer>
          <Label label={intl.formatMessage({ id: "crs.q6" })} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={CRS.CRS_Q6}
            optionList={modifyOptions(CRS.CRS_Q6)}
            onCheckMarkChange={this.onBoolChange}
            defaultValue={translateAnswer(question6)}
            isValid={elementValidation[CRS.CRS_Q6].isValid}
            errorMessage={elementValidation[CRS.CRS_Q6].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {(translateAnswer(question6) === intl.formatMessage({ id: "yes" }) ||
          question6 === `${CRS.CRS_Q6}_yes`) && (
          <FormElementContainer isWithPadding isLightBg>
            <Textarea
              label={intl.formatMessage({ id: "crs.q6.ifYes" })}
              name={CRS.EFFECTIVE_POA}
              onInputChange={this.onElementChange}
              value={effectivePoa}
              isValid={elementValidation[CRS.EFFECTIVE_POA].isValid}
              errorMessage={elementValidation[CRS.EFFECTIVE_POA].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />
          </FormElementContainer>
        )}

        <br />
        <hr />
        <br />

        <Heading title={intl.formatMessage({ id: "crs.q7" })} />

        {taxList &&
          taxList.map((form, idx) => (
            <FormElementContainer
              key={form.id}
              id={form.id}
              isWithPadding
              isLightBg
              isWithClose={idx > 0}
              onClose={() => this.handleRemoveCountryTax(form.id)}
            >
              <FormElementContainer>
                <SimpleSelectBox
                  name={`${COUNTRY_TAX.COUNTRY_JURISDICTION}-${idx}`}
                  label={intl.formatMessage({ id: "crs.countryJurisdiction" })}
                  placeholder={intl.formatMessage({
                    id: "crs.countryJurisdiction.placeholder",
                  })}
                  dataList={this.getJurisdictions(isKuwaiti && idx !== 0)}
                  onSelect={(a, b) =>
                    this.onHandleSelect(
                      idx,
                      COUNTRY_TAX.COUNTRY_JURISDICTION,
                      b,
                    )
                  }
                  isSearchInputDisabled={false}
                  defaultValue={form[COUNTRY_TAX.COUNTRY_JURISDICTION]}
                  isDisabled={isKuwaiti && idx === 0 && !isEmpty(civilId)}
                />
              </FormElementContainer>

              <FormElementContainer>
                <Label label={intl.formatMessage({ id: "crs.isTin" })} />
                <Options
                  isMultpleElements
                  type="radio"
                  hasContainer
                  useLabel
                  name={`${COUNTRY_TAX.IS_TIN}-${idx}`}
                  // name={COUNTRY_TAX.IS_TIN}
                  optionList={modifyOptions(COUNTRY_TAX.IS_TIN).map((x, i) => ({
                    id: `${form[COUNTRY_TAX.COUNTRY_JURISDICTION].replace(/\s/g, "")}-${x.id}${i}`,
                    label: x.label,
                  }))}
                  onCheckMarkChange={(e) =>
                    this.onUpdateIsTin(idx, COUNTRY_TAX.IS_TIN, e)
                  }
                  // onCheckMarkChange={e => this.onCountryTaxChange(idx, e)}
                  defaultValue={translateAnswer(form[COUNTRY_TAX.IS_TIN])}
                  // isValid={elementValidation[CRS.CRS_Q4].isValid}
                  // errorMessage={elementValidation[CRS.CRS_Q4].errorMessage}
                  // isSubmitClicked={isSubmitClicked}
                  isDisabledForAll={isKuwaiti && idx === 0 && !isEmpty(civilId)}
                />
              </FormElementContainer>

              {translateAnswer(form.isTin) ===
                intl.formatMessage({ id: "yes" }) && (
                <FormElementContainer>
                  <Input
                    name={COUNTRY_TAX.TIN}
                    label={intl.formatMessage({ id: "crs.tin" })}
                    placeholder={intl.formatMessage({
                      id: "crs.tin.placeholder",
                    })}
                    onInputChange={(e) => this.onCountryTaxChange(idx, e)}
                    value={form[COUNTRY_TAX.TIN]}
                    disabled={isKuwaiti && idx === 0 && !isEmpty(civilId)}
                  />
                </FormElementContainer>
              )}

              {translateAnswer(form.isTin) ===
                intl.formatMessage({ id: "no" }) && (
                <FormElementContainer>
                  <SelectBox
                    name={`${COUNTRY_TAX.REASON_OPTION}-${idx}`}
                    label={intl.formatMessage({ id: "crs.tinNotIssued" })}
                    placeholder={intl.formatMessage({ id: "crs.selectReason" })}
                    dataList={taxReasonOptions}
                    onSelect={(a, b) =>
                      this.onHandleSelect(idx, COUNTRY_TAX.REASON_OPTION, b)
                    }
                    defaultValue={form[COUNTRY_TAX.REASON_OPTION]}
                  />
                  {form[COUNTRY_TAX.REASON_OPTION] === "REASON-B" && (
                    <Input
                      name={COUNTRY_TAX.REASON_TIN_NOT_ISSUED}
                      label={intl.formatMessage({ id: "crs.enterReason" })}
                      placeholder={intl.formatMessage({ id: "crs.myReason" })}
                      onInputChange={(e) => this.onCountryTaxChange(idx, e)}
                      value={form[COUNTRY_TAX.REASON_TIN_NOT_ISSUED]}
                    />
                  )}
                </FormElementContainer>
              )}
            </FormElementContainer>
          ))}

        {!isCountryTaxValid && isSubmitClicked && (
          <span
            className="notification notification--error"
            style={{ marginTop: "5px" }}
          >
            {intl.formatMessage({ id: "validation.countryTax" })}
          </span>
        )}

        {taxList &&
          taxList.some(
            (x) =>
              translateAnswer(x.isTin) === intl.formatMessage({ id: "no" }),
          ) && (
            <Notes
              msg={
                <div>
                  <FormattedHTMLMessage id="reasonA" />
                  <FormattedHTMLMessage id="reasonB" />
                  <FormattedHTMLMessage id="reasonC" />
                </div>
              }
            />
          )}

        <ButtonPlus
          label={intl.formatMessage({ id: "crs.addMoreTin" })}
          onButtonClick={onAddMoreCountryTax}
        />
      </PaddedContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  appLanguage: selectors.getLanguage(state),
  question1: selectors.getCrsQ1(state),
  question2: selectors.getCrsQ2(state),
  question3: selectors.getCrsQ3(state),
  question4: selectors.getCrsQ4(state),
  question5: selectors.getCrsQ5(state),
  question6: selectors.getCrsQ6(state),
  residentJurisdiction: selectors.getCrsResidentJurisdiction(state),
  residenceAddress: selectors.getCrsResidenceAddress(state),
  telephone: selectors.getCrsTelephone(state),
  standingInstruction: selectors.getCrsStandingInstruction(state),
  holdMail: selectors.getCrsHoldMail(state),
  effectivePoa: selectors.getCrsEffectivePoa(state),
  taxList: selectors.getTaxList(state),
  civilId: selectors.getCivilId(state),
  clientDetails: selectors.getClientDetails(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
});

const mapDispatchToProps = (dispatch) => ({
  onUpdateCrs: (name, value) => dispatch(fatcaCrsAction.updateCrs(name, value)),

  onAddMoreCountryTax: () => dispatch(fatcaCrsAction.addMoreCountryTax()),
  onUpdateCountryTax: (index, key, value) =>
    dispatch(fatcaCrsAction.updateCountryTax(index, key, value)),
  onRemoveCountryTax: (id) => dispatch(fatcaCrsAction.removeCountryTaxItem(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Crs));
